import * as ActionTypes from 'state/types'

export default (state = {
  isRequesting: false,
  threads: []
}, action) => {
  switch (action.type) {

    case ActionTypes.SELECT_INTERACTION:
      return {
        ...state,
        threads: [],
        isRequesting: false
      }

    case `${ActionTypes.PAUSES_REQUEST}_START`:
    case `${ActionTypes.SAVE_PAUSES_REQUEST}_START`:
    case `${ActionTypes.DELETE_PAUSES_REQUEST}_START`:
      return {
        ...state,
        isRequesting: true
      }

    case `${ActionTypes.PAUSES_REQUEST}_SUCCESS`:
      return {
        ...state,
        isRequesting: false,
        threads: action.response.items
      }
    case `${ActionTypes.SAVE_PAUSES_REQUEST}_SUCCESS`:
    case `${ActionTypes.DELETE_PAUSES_REQUEST}_SUCCESS`:
      return {
        ...state,
        isRequesting: false
      }

    case ActionTypes.RECEIVE_UPDATED_PAUSE: {
      const {
        pause
      } = action

      const {
        channelId,
        threadId
      } = pause

      if(state.threads.find(t => t.threadId === threadId && t.channelId === channelId)) {
        return state
      }

      const copyThreads = [
        ...state.threads
      ]
      copyThreads.push({
        channelId,
        threadId
      })

      return {
        ...state,
        threads: copyThreads
      }
    }

    case ActionTypes.RECEIVE_DELETED_PAUSE: {
      const {
        pause
      } = action

      const {
        channelId,
        threadId
      } = pause

      const deletedIndex = state.threads.findIndex(t => t.threadId === threadId && t.channelId  === channelId)
      if(deletedIndex === -1) {
        return state
      }

      const copyThreads = [
        ...state.threads
      ]
      copyThreads.splice(deletedIndex, 1)

      return {
        ...state,
        threads: copyThreads
      }
    }

    case `${ActionTypes.PAUSES_REQUEST}_FAIL`:
    case `${ActionTypes.SAVE_PAUSES_REQUEST}_FAIL`:
    case `${ActionTypes.DELETE_PAUSES_REQUEST}_FAIL`:

      return {
        ...state,
        isRequesting: false
      }

    default:
      return state
  }
}
